import React, { createContext, useContext, useState } from 'react';

type Language = 'en' | 'ja';

interface I18nContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const translations: Record<Language, Record<string, string>> = {
  en: {
    'welcome': 'Welcome',
    'login': 'Login',
    'signup': 'Sign Up',
    'logout': 'Logout',
    'dashboard': 'Dashboard',
    'courses': 'Courses',
    'settings': 'Settings',
    'profile': 'Profile',
    'password': 'Password',
  },
  ja: {
    'welcome': 'ようこそ',
    'login': 'ログイン',
    'signup': '新規登録',
    'logout': 'ログアウト',
    'dashboard': 'ダッシュボード',
    'courses': 'コース',
    'settings': '設定',
    'profile': 'プロフィール',
    'password': 'パスワード',
  },
};

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState<Language>('ja');

  const t = (key: string): string => {
    return translations[language][key] || key;
  };

  return (
    <I18nContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
}